import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#1f2328',
        color: '#fff',
        borderTop: '1px solid rgba(255,255,255,0.08)',
        pt: { xs: 4, md: 5 },
        pb: 'calc(env(safe-area-inset-bottom, 0px) + 24px)',
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={2.5} alignItems="center" textAlign="center">
          <Box
            component="img"
            src="/logo-white.png?v=20260611"
            alt="IDECONECTA"
            sx={{
              width: { xs: 180, md: 240 },
              maxWidth: '70vw',
              height: 'auto',
              objectFit: 'contain',
            }}
          />

          <Typography sx={{ fontWeight: 700, fontSize: { xs: '1rem', md: '1.12rem' }, color: '#fff' }}>
            Uma comunidade de empresários que compram, vendem e crescem juntos.
          </Typography>

          <Stack direction="row" spacing={{ xs: 2, sm: 3 }} flexWrap="wrap" justifyContent="center">
            <Typography
              component={Link}
              to="/privacidade"
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
            >
              Privacidade
            </Typography>
            <Typography
              component={Link}
              to="/termos"
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
            >
              Termos de Uso
            </Typography>
            <Typography
              component={Link}
              to="/suporte"
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.7)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
            >
              Suporte
            </Typography>
            <Typography
              component={Link}
              to="/excluir-conta"
              variant="body2"
              sx={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none', '&:hover': { color: '#fff' } }}
            >
              Excluir Conta
            </Typography>
          </Stack>

          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.58)' }}>
            © {new Date().getFullYear()} IDEBRASIL. Todos os direitos reservados.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
